import { Obstruction } from '../obstruction.class';
import { Size } from '../../../types';

export const getOverallSizeCfn = (island: Obstruction): Size => {
	// NOTE: Doesn't take into considuration corner island angle
	const { islandSize, panels } = island;

	const pFront = panels.getFrontPanel();
	const pLeft = panels.findById(pFront.connections.left.targetPanelId);
	const pRight = panels.findById(pFront.connections.right.targetPanelId);
	const pBackLeft = panels.findById(pLeft.connections.left.targetPanelId);
	const pBackRight = panels.findById(pLeft.connections.right.targetPanelId);

	return {
		width: islandSize.width + pLeft.countertopOverhang + pRight.countertopOverhang,
		height: islandSize.height + island.panels.surroundMaterial.thickness,
		depth: islandSize.depth + pFront.countertopOverhang +
			Math.max(pBackLeft.countertopOverhang, pBackRight.countertopOverhang)
	};
};
